var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9741 2.20295C1.81167 2.41581 1.697 2.4546 1.697 2.27447V1.94768C1.697 1.47906 1.31712 1.09917 0.848502 1.09917C0.379886 1.09917 0 1.47906 0 1.94768V4.85683C0 5.32544 0.379886 5.70533 0.848502 5.70533H3.75765C4.22627 5.70533 4.60615 5.32544 4.60615 4.85683C4.60615 4.38821 4.22627 4.00832 3.75765 4.00832C3.75765 4.00832 3.61729 4.00832 3.44395 4.00832C3.27061 4.00832 3.22188 3.81026 3.3688 3.5865C4.03596 2.57145 5.17974 1.93919 6.41589 1.93919C8.42562 1.93919 10.0606 3.57413 10.0606 5.58387C10.0606 7.59337 8.42562 9.22831 6.41589 9.22831C5.88036 9.22831 5.44617 9.6625 5.44617 10.198C5.44617 10.7336 5.88036 11.1677 6.41589 11.1677C9.49498 11.168 12 8.66296 12 5.58411C12 2.50502 9.49498 5.26724e-08 6.41589 5.26724e-08C4.65561 -0.000242376 3.01703 0.836381 1.9741 2.20295Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.3e6627d235014dadfcdf23a60717ece1.svg";
export { ForwardRef as ReactComponent };